import { Alert } from 'antd'
import styled from 'styled-components'

const AlertStyled = styled(Alert)`
  padding: 12px 10px;
  width: fit-content;
`

export default AlertStyled
